import { z } from "zod";
import { defineEvent } from "./registry.js";
/** Fiş kesinleşti. Alt defter modülleri ve raporlama önbellekleri bu olayı dinler. */
export const journalEntryPostedV1 = defineEvent({
    type: "accounting.journal_entry.posted",
    version: 1,
    description: "Muhasebe fişi kesinleşti ve yevmiye madde numarası aldı",
    realtime: ["tenant"],
    payload: z.object({
        entryId: z.uuid(),
        companyId: z.uuid(),
        entryNo: z.string(),
        fiscalYear: z.number().int(),
        postingDate: z.iso.date(),
        source: z.string(),
        sourceDocType: z.string().nullable(),
        sourceDocId: z.uuid().nullable(),
        totalAmount: z.string(),
    }),
});
export const journalEntryReversedV1 = defineEvent({
    type: "accounting.journal_entry.reversed",
    version: 1,
    description: "Kesinleşmiş fişin ters kaydı alındı",
    realtime: ["tenant"],
    payload: z.object({
        entryId: z.uuid(),
        reversalEntryId: z.uuid(),
        companyId: z.uuid(),
        source: z.string(),
        sourceDocType: z.string().nullable(),
        sourceDocId: z.uuid().nullable(),
    }),
});
/** ALARM: kayıt oluşturulamadı, eşleştirme bekleyenler kuyruğuna düştü (alarm modülü: Prompt 20). */
export const postingExceptionRaisedV1 = defineEvent({
    type: "accounting.posting_exception.raised",
    version: 1,
    description: "Muhasebe kaydı oluşturulamadı; eşleştirme bekleyenler kuyruğuna düştü",
    realtime: ["tenant"],
    payload: z.object({
        exceptionId: z.uuid(),
        companyId: z.uuid(),
        reason: z.enum(["MAPPING_MISSING", "ACCOUNT_NOT_POSTABLE", "DIMENSION_MISSING"]),
        missingKeys: z.array(z.string()),
        source: z.string(),
        sourceDocType: z.string(),
        sourceDocId: z.uuid(),
    }),
});
export const fiscalPeriodStatusChangedV1 = defineEvent({
    type: "accounting.fiscal_period.status_changed",
    version: 1,
    description: "Mali dönemin durumu değişti (kapatma / yeniden açma)",
    realtime: ["tenant"],
    payload: z.object({
        periodId: z.uuid(),
        companyId: z.uuid(),
        year: z.number().int(),
        periodNo: z.number().int(),
        from: z.enum(["OPEN", "SOFT_CLOSED", "CLOSED"]),
        to: z.enum(["OPEN", "SOFT_CLOSED", "CLOSED"]),
    }),
});
//# sourceMappingURL=accounting.v1.js.map